import { defineMessages } from 'react-intl';
var messages = defineMessages({
    Total: { id: 'Total', defaultMessage: 'Total' },
    Blocked: { id: 'Blocked', defaultMessage: 'Blocked' },
    PastDeadline: { id: 'PastDeadline', defaultMessage: 'Past deadline' },
    DeadlineOneWeek: { id: 'DeadlineOneWeek', defaultMessage: 'Deadline one week' },
    DeadlineTwoWeeks: { id: 'DeadlineTwoWeeks', defaultMessage: 'Deadline two weeks' },
    DeadlineThreeWeeks: { id: 'DeadlineThreeWeeks', defaultMessage: 'Deadline three weeks' },
    DeadlineFourWeeks: { id: 'DeadlineFourWeeks', defaultMessage: 'Deadline four weeks' },
    deadlineThreeMonths: { id: 'DeadlineThreeMonths', defaultMessage: 'Deadline three months' },
    deadlineSixMonths: { id: 'DeadlineSixMonths', defaultMessage: 'Deadline six months' },
    deadlineOneYear: { id: 'DeadlineOneYear', defaultMessage: 'Deadline one year' },
    executionDateBeforeThisWeek: {
        id: 'executionDateBeforeThisWeek',
        defaultMessage: 'Execution date before current week',
    },
    executionDateThisWeek: {
        id: 'executionDateThisWeek',
        defaultMessage: 'Execution date this week',
    },
    executionDateNextWeek: {
        id: 'executionDateNextWeek',
        defaultMessage: 'Execution date next week',
    },
    executionDateInTwoWeeks: {
        id: 'executionDateInTwoWeeks',
        defaultMessage: 'Execution date in two weeks',
    },
    executionDateInThreeWeeks: {
        id: 'executionDateInThreeWeeks',
        defaultMessage: 'Execution date in three weeks',
    },
    OnlyCountTheTasksWhereIAmTheNextAssignedUser: {
        id: 'OnlyCountTheTasksWhereIAmTheNextAssignedUser',
        defaultMessage: 'OnlyCountTheTasksWhereIAmTheNextAssignedUser',
    },
});
export default messages;
var mapping = {
    total: messages.Total,
    blocked: messages.Blocked,
    pastDeadline: messages.PastDeadline,
    deadlineOneWeek: messages.DeadlineOneWeek,
    deadlineTwoWeeks: messages.DeadlineTwoWeeks,
    deadlineThreeWeeks: messages.DeadlineThreeWeeks,
    deadlineFourWeeks: messages.DeadlineFourWeeks,
    deadlineThreeMonths: messages.deadlineThreeMonths,
    deadlineSixMonths: messages.deadlineSixMonths,
    deadlineOneYear: messages.deadlineOneYear,
    nextUserIsMe: messages.OnlyCountTheTasksWhereIAmTheNextAssignedUser,
    executionDateBeforeThisWeek: messages.executionDateBeforeThisWeek,
    executionDateThisWeek: messages.executionDateThisWeek,
    executionDateNextWeek: messages.executionDateNextWeek,
    executionDateInTwoWeeks: messages.executionDateInTwoWeeks,
    executionDateInThreeWeeks: messages.executionDateInThreeWeeks,
};
export var getKpiMessage = function (kpi) {
    return mapping[kpi];
};
